export type TruthpickTopic = '일상' | '지식' | '논쟁' | '미스터리';

type PostWithId = {
    id: number;
};

const TOPIC_MAP: Record<TruthpickTopic, string[]> = {
    일상: ['free', '기타', '일상', '문화', '연예'],
    지식: ['과학', '건강', '심리학', 'IT', 'AI', '경제', '퀴즈'],
    논쟁: ['논란', '사회', '정치', '종교', '게임'],
    미스터리: ['미스터리', '괴담', '충격', '실화', '넌센스']
};

export const normalizeTopic = (category?: string | null): TruthpickTopic => {
    const matched = (Object.keys(TOPIC_MAP) as TruthpickTopic[])
        .find((topic) => TOPIC_MAP[topic].includes(category || ''));

    return matched || '일상';
};

export const cleanClaim = (content: string, maxLength = 90): string => {
    const cleaned = (content || '')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    if(cleaned.length <= maxLength) {
        return cleaned;
    }

    return `${cleaned.slice(0, maxLength).trim()}…`;
};

const dateSeed = (date: Date): number => (
    date.getFullYear() * 10000
    + (date.getMonth() + 1) * 100
    + date.getDate()
);

const scoreFor = (id: number, seed: number): number => {
    let value = (id * 2654435761) ^ seed;
    value ^= value << 13;
    value ^= value >>> 17;
    value ^= value << 5;
    return value >>> 0;
};

export const selectDailyPosts = <T extends PostWithId>(
    posts: T[],
    date: Date,
    limit = 5
): T[] => {
    const uniquePosts = Array.from(
        new Map(posts.map((post) => [post.id, post])).values()
    );
    const seed = dateSeed(date);

    return uniquePosts
        .sort((first, second) => scoreFor(first.id, seed) - scoreFor(second.id, seed))
        .slice(0, Math.max(0, limit));
};

export const votePercentages = (truthVotes: number, lieVotes: number) => {
    const truth = Math.max(0, truthVotes || 0);
    const lie = Math.max(0, lieVotes || 0);
    const total = truth + lie;

    if(total === 0) {
        return { truth: 50, lie: 50 };
    }

    const truthPercent = Math.round((truth / total) * 100);
    return {
        truth: truthPercent,
        lie: 100 - truthPercent
    };
};

